import $http from "../../helpers/api";

// initial state
const state = {
  all: [],
  user: []
};

// getters
const getters = {
  getUser() {
    return state.user;
  },
  getAsf(state, getters, rootState, rootGetters) {
    if (rootState.auth.roles) {
      if (rootState.auth.roles.includes("admin")) {
        return rootState.auth.currentAsf;
      } else {
        return rootGetters["auth/getAsf"][0];
      }
    }
  }
};

// actions
const actions = {
  getAllUsers({ commit, rootGetters }) {
    return new Promise((resolve, reject) => {
      $http
        .get("/users", {
          params: {
            includes: ["roles", "asfs"],
            filter_groups: [
              {
                filters: [
                  {
                    key: "asfs",
                    value: rootGetters["auth/getCurrentAsf"],
                    operator: "eq"
                  }
                ]
              }
            ]
          }
        })
        .then(resp => {
          let arr = [];
          resp.data.users.forEach(function(item, i) {
            arr[i] = {
              id: item.id,
              name: item.name,
              email: item.email,
              asf: item.asfs.map(o => o["name"]).join(", "),
              role: item.roles.map(o => o["name"]).join(", ")
            };
          });
          commit("setUsers", arr);
        });
      resolve();
    });
  },
  getUser({ commit }, userId) {
    return new Promise(resolve => {
      $http
        .get("/users/" + userId + "?includes[]=roles&includes[]=asfs")
        .then(resp => {
          let arr = {
            id: resp.data.user.id,
            email: resp.data.user.email,
            asf: resp.data.user.asfs,
            name: resp.data.user.name,
            role: resp.data.user.roles.map(o => o["name"])
          };
          commit("setUser", arr);
        });
      resolve();
    });
  },
  addUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .post("/users", { user: data })
        .then(resp => {
          commit("clearUser");
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  editUser({ commit }, data) {
    return new Promise((resolve, reject) => {
      $http
        .put("/users/" + data.id, { user: data })
        .then(resp => {
          commit("clearUser");
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  resetPass({ commit }, id) {
    return new Promise((resolve, reject) => {
      $http
        .get("/users/reset/" + id)
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteUser({}, data) {
    return new Promise((resolve, reject) => {
      $http
        .delete("/users/" + data)
        .then(resp => {
          resolve(resp);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

// mutations
const mutations = {
  setUsers(state, users) {
    state.all = users;
  },
  setUser(state, user) {
    state.user = user;
  },
  clearUser(state) {
    state.user = [];
  },
  clearAll(state) {
    state.user = [];
    state.all = [];
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
